<template>
    <div>
        <table class="table table-hover table-responsive" v-bind:id="id" width="100%">
            <thead> </thead>
            <tbody> </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "TableAutorizacionDeclaraciones",
    props: { id: '', data_: [], lengthMenu: [] },
    mounted() {
        this.createTable();
        window.authdeclaraciones = this;
    },
    methods: {
        accionVer(dato) {
            this.$emit('ver', dato);
        },
        accionDetalle(dato) {
            this.$emit('detalle', dato);
        },
        accionEliminar(dato) {
            this.$emit('eliminar', dato);
        },
        createTable() {
            $('#sample_2').DataTable({
                "data": this.data_,
                deferRender: true,
                scrollX: true,
                scrollCollapse: true,
                scroller: true,
                "lengthMenu": [
                    [10, 15, 25, 50, 100, -1],
                    [10, 15, 25, 50, 100, "All"]
                ],
                order: [
                    [8, 'asc'],   //#Estatus
                    [0, 'asc'],   //#RFC
                    [1, 'asc'],   //#Cuenta
                    [3, 'desc']   //#Año
                ],
                "columns": [
                    { "data": "numero_oficio", "title": "NO. DE OFICIO" },
                    { "data": "rfc", "title": "RFC" },
                    { "data": "numero_cuenta", "title": "CUENTA" },
                    { "data": "nombre_razon_social", "title": "NOMBRE O RAZÓN SOCIAL" },
                    { "data": "obligacion_fiscal", "title": "OBLIGACIÓN" },
                    { "data": "folio_declaracion", "title": "FOLIO DECLARACIÓN" },
                    { "data": "tipo_declaracion", "title": "TIPO" },
                    { "data": "periodo_declarado", "title": "PERIODO DECLARADO" },
                    { "data": "estatus", "render": this.spanEstatus, "title": "ESTATUS" },
                    { "data": "estatus", "render": this.btnDetalle, "title": "ACCIONES" }
                ]
            });
        },
        btnDetalle(data, type, row, meta) {
            let btn = "";
            if (data) {
                btn = "<a class='btn btn-icon-only btn-circle green' title='Ver Detalle' onclick='accionVer(" + JSON.stringify(row) + ")'><i class='fa fa-eye'></i></a><a class='btn btn-icon-only btn-circle btn-danger' title='Eliminar Registro' onclick='accionEliminar(" + JSON.stringify(row) + ")'><i class='fa fa-trash'></i></a>";
            }
            return btn;
        },
        checkInfo(data, type, row, meta) {
            let ch = "";
            if (data) {
                ch = "<i class='fa  fa-check-circle-o font-green'></i>"
            }
            return ch;
        },
        spanEstatus(data, type, row, meta) {
            let s = data == 'VIGENTE' ? 'btn-success' : 'label-warning';
            let status = data;
            return '<span class="label  btn-circle ' + s + '" class="">' + status + ' </span>';
        }
    }
}
</script>
<style scoped>
table.dataTable tbody td {
    word-break: break-word;
    word-break: break-all;
    white-space: normal;
}
</style>
